import { useLanguage } from "@tlc/ls2pac/components/Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import React from "react";

export const HoldPickupInfo: React.FC<{ hold: HostSystemItemView }> = ({
  hold,
}) => {
  const { translate } = useLanguage();
  return (
    <>
      {!hold.downloadable && (
        <div className="pickupInfo">
          {translate("pickupLocation")} <strong>{hold.holdPickupBranch}</strong>{" "}
          {hold.status === "AR" &&
            !hold.suspendUntilDate &&
            hold.holdPickupBy && (
              <>
                {translate("by")}{" "}
                <strong className="pickupDate">
                  {hold.holdPickupByString}
                </strong>
              </>
            )}
        </div>
      )}
    </>
  );
};
